import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { DiganosticEntryComponent } from '../diganostic-entry/diganostic-entry.component';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import { DiganosisModel } from 'src/app/models/DiganosisModel';
import { DiganosisService } from 'src/app/services/DiganosisService';
import { CanserService } from 'src/app/services/CanserService';
import { CanserModel } from 'src/app/models/CanserModel';
import swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-diganostic',
  templateUrl: './diganostic.component.html',
  styleUrls: ['./diganostic.component.css']
})
export class DiganosticComponent implements OnInit {
  patientcode = '' ;
  Patientname = '';

  OriginalDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  digdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diglocation = '' ;
  cancerid = '' ;
  CancerName = '';
  tissue = '' ;
  histology = '' ;
  grade = '' ;
  er = '' ;
  pdl1 = '' ;
  msi = '' ;
  egfr = '' ;
  alk = '' ;
  her2 = '' ;
  kras = '' ;
  braf = '' ;
  hrd = '' ;
  brca1 = '' ;
  brca2 = '' ;
  gscore = '' ;
  nfeature = '' ;
  pr = '' ;
  her2ihs = '' ;
  her2fish = '' ;
  ki67 = 0 ;
  hpv = '' ;
  digsite = '' ;
  digstage = '' ;
  digt = '' ;
  dign = '' ;
  digm = '' ;
  dignotes = '' ;
  userid = '';
  username = '';
  dignosisdiscription = '';
  wk_font = 2;
  wk_fontsize = '2ch';
  DiganosiseList : DiganosisModel[]=[];
  disablepharnacy = false;
  maxCharsPerLine = 75;
  cancername = '';
  wk_Heddin_histology : boolean[] = [];
  wk_Heddin_grade : boolean[] = [];
  wk_Heddin_er : boolean[] = [];
  wk_Heddin_pdl1 : boolean[] = [];
  wk_Heddin_msi : boolean[] = [];
  wk_Heddin_egfr : boolean[] = [];
  wk_Heddin_alk : boolean[] = [];
  wk_Heddin_her2 : boolean[] = [];
  wk_Heddin_kras : boolean[] = [];
  wk_Heddin_braf : boolean[] = [];
  wk_Heddin_hrd : boolean[] = [];
  wk_Heddin_brca1 : boolean[] = [];
  wk_Heddin_brca2 : boolean[] = [];
  wk_Heddin_gscore : boolean[] = [];
  wk_Heddin_pr : boolean[] = [];
  wk_Heddin_nfeature : boolean[] = [];
  wk_Heddin_her2ihs : boolean[] = [];
  wk_Heddin_her2fish: boolean[] = [];
  wk_Heddin_ki67 : boolean[] = [];
  wk_Heddin_hpv : boolean[] = [];
  wk_Heddin_digstage : boolean[] = [];
  wk_Heddin_dign  : boolean[] = [];
  wk_Heddin_digm : boolean[] = [];
  wk_Heddin_digt  : boolean[] = [];
  chkuser = '';
  constructor(public stores: LkpStoresModel,
              private dialogref: MatDialog,
              public storage: LocalStorageService,
              public diganosis : DiganosisModel,
              public diganosisService : DiganosisService,
              public CanserService : CanserService,
              private router : Router) { }

  ngOnInit(): void {
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.digdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.RetriveDiganosis();
    if(this.storage.retrieve('stgGroup') !='2' || this.storage.retrieve('stgGroup') !='8'){this.disablepharnacy = true}else{this.disablepharnacy = false}
  }
  ZoomIn(){
    this.wk_font  = this.wk_font  + 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  ZoomOut(){
    this.wk_font  = this.wk_font  - 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  limitLineLength() {

    let lines = this.dignotes.split("\n"); // Split by manual Enter presses
    let formattedLines: string[] = [];

    for (let line of lines) {
      while (line.length > this.maxCharsPerLine) {
        formattedLines.push(line.substring(0, this.maxCharsPerLine)); // Add first 30 chars
        line = line.substring(this.maxCharsPerLine); // Remove added part
      }
      formattedLines.push(line); // Add remaining part
    }

    this.dignotes = formattedLines.join("\n"); // Preserve manual and auto lin
  }
RetriveDiganosis(){
           this.DiganosiseList = [];
           this.diganosisService.getDiganosisPatient(this.patientcode).subscribe((data: DiganosisModel[]) => {
              for (let i = 0; i < data.length; i++) {
                this.DiganosiseList[i] = data[i];
                var notes =  this.DiganosiseList[i].dignotes;
                var canid = this.DiganosiseList[i].cancerid;
                // this.CanserService.getCancer(data[i].cancerid,'1').subscribe((data1:CanserModel)=>{
                //   this.cancername =data1.cancerName;
                  this.DiganosiseList[i].cancerid = 'Cancer Type :' + data[i].cancerid;
                //   debugger;
                // })

                this.DiganosiseList[i].digdate =formatDate(data[i].digdate, 'yyyy-MM-dd', 'en');

                this.DiganosiseList[i].tissue =  ' Site of specimen :' + this.DiganosiseList[i].tissue;
                if (this.DiganosiseList[i].histology =='' || this.DiganosiseList[i].histology ==null){this.DiganosiseList[i].histology ='';this.wk_Heddin_histology[i] = true;} else{ this.DiganosiseList[i].histology =  'Histology :' + this.DiganosiseList[i].histology ;this.wk_Heddin_histology[i] = false; };
                if (this.DiganosiseList[i].grade =='' || this.DiganosiseList[i].grade ==null){this.DiganosiseList[i].grade = '';this.wk_Heddin_grade[i] = true;}else{ this.DiganosiseList[i].grade =  'Grade :' + this.DiganosiseList[i].grade;this.wk_Heddin_grade[i] = false;};
                if (this.DiganosiseList[i].er =='' || this.DiganosiseList[i].er ==null){this.DiganosiseList[i].er = '';this.wk_Heddin_er[i] = true; }else{ this.DiganosiseList[i].er= 'ER :' + this.DiganosiseList[i].er;this.wk_Heddin_er[i] = false; };
                if (this.DiganosiseList[i].pdl1 =='' || this.DiganosiseList[i].pdl1 ==null){this.DiganosiseList[i].pdl1 = '' ;this.wk_Heddin_pdl1[i] = true;}else{ this.DiganosiseList[i].pdl1 =  'PDL1 :' + this.DiganosiseList[i].pdl1;this.wk_Heddin_pdl1[i] = false;};
                if (this.DiganosiseList[i].msi =='' || this.DiganosiseList[i].msi ==null){this.DiganosiseList[i].msi = '';this.wk_Heddin_msi[i] = true; }else{ this.DiganosiseList[i].msi = 'MSI :' + this.DiganosiseList[i].msi;this.wk_Heddin_msi[i] = false;};
                if (this.DiganosiseList[i].egfr =='' || this.DiganosiseList[i].egfr ==null){this.DiganosiseList[i].egfr = '';this.wk_Heddin_egfr[i] = true }else{ this.DiganosiseList[i].egfr = 'EGFR :'  + this.DiganosiseList[i].egfr;this.wk_Heddin_egfr[i] =false};
                if (this.DiganosiseList[i].alk =='' || this.DiganosiseList[i].alk ==null){this.DiganosiseList[i].alk = '';this.wk_Heddin_alk[i] = true; }else{ this.DiganosiseList[i].alk = 'ALK :'+ this.DiganosiseList[i].alk;this.wk_Heddin_alk[i] = false;};
                if (this.DiganosiseList[i].her2 =='' || this.DiganosiseList[i].her2 ==null){this.DiganosiseList[i].her2 = '';this.wk_Heddin_her2[i] = true; }else{ this.DiganosiseList[i].her2 = 'HER2 :' + this.DiganosiseList[i].her2;this.wk_Heddin_her2[i] =false;};
                if (this.DiganosiseList[i].kras =='' || this.DiganosiseList[i].kras ==null){this.DiganosiseList[i].kras = '';this.wk_Heddin_kras[i] =true; }else{ this.DiganosiseList[i].kras = 'KRAS :' + this.DiganosiseList[i].kras;this.wk_Heddin_kras[i] =false;};
                if (this.DiganosiseList[i].braf =='' || this.DiganosiseList[i].braf ==null){this.DiganosiseList[i].braf = '';this.wk_Heddin_braf[i] = true; }else{ this.DiganosiseList[i].braf = 'BRAF :' + this.DiganosiseList[i].braf;this.wk_Heddin_braf[i] = false;};
                if (this.DiganosiseList[i].hrd =='' || this.DiganosiseList[i].hrd ==null){this.DiganosiseList[i].hrd = ''; this.wk_Heddin_hrd[i] =true }else{ this.DiganosiseList[i].hrd = 'HRD :' + this.DiganosiseList[i].hrd;this.wk_Heddin_hrd[i] = false;};
                if (this.DiganosiseList[i].brca1 =='' || this.DiganosiseList[i].brca1 ==null){this.DiganosiseList[i].brca1 ='';this.wk_Heddin_brca1[i] = true; }else{ this.DiganosiseList[i].brca1 = 'BRCA1 :'  + this.DiganosiseList[i].brca1;this.wk_Heddin_brca1 [i]= false;};
                if (this.DiganosiseList[i].brca2 =='' || this.DiganosiseList[i].brca2 ==null){this.DiganosiseList[i].brca2 ='';this.wk_Heddin_brca2[i] = true; }else{ this.DiganosiseList[i].brca2 = 'BRCA2 :' +  this.DiganosiseList[i].brca2;this.wk_Heddin_brca2[i] = false;};
                if (this.DiganosiseList[i].gscore =='' || this.DiganosiseList[i].gscore ==null){this.DiganosiseList[i].gscore = '';this.wk_Heddin_gscore[i] = true;}else{ this.DiganosiseList[i].gscore = 'Gleason Score :' +  this.DiganosiseList[i].gscore;this.wk_Heddin_gscore[i]=false;};
                if (this.DiganosiseList[i].pr =='' || this.DiganosiseList[i].pr ==null){this.DiganosiseList[i].pr = '';this.wk_Heddin_pr[i] = true; }else{ this.DiganosiseList[i].pr = 'PR :' + this.DiganosiseList[i].pr;this.wk_Heddin_pr[i] = false; };
                if (this.DiganosiseList[i].nfeature =='' || this.DiganosiseList[i].nfeature ==null){this.DiganosiseList[i].nfeature = '';this.wk_Heddin_nfeature[i] = true; }else{ this.DiganosiseList[i].nfeature = 'Neuroendocrine features :' + this.DiganosiseList[i].nfeature;this.wk_Heddin_nfeature[i] = false; };
                if (this.DiganosiseList[i].her2ihs =='' || this.DiganosiseList[i].her2ihs ==null){this.DiganosiseList[i].her2ihs = '';this.wk_Heddin_her2ihs[i] =true; }else{ this.DiganosiseList[i].her2ihs = 'HER2 score by IHC:' +  this.DiganosiseList[i].her2ihs;this.wk_Heddin_her2ihs[i] =false; };
                if (this.DiganosiseList[i].her2fish =='' || this.DiganosiseList[i].her2fish ==null){this.DiganosiseList[i].her2fish = '';this.wk_Heddin_her2fish[i] = true; }else{ this.DiganosiseList[i].her2fish = 'HER2 score by FISH:' +  this.DiganosiseList[i].her2fish;this.wk_Heddin_her2fish[i]=false; };
                if (this.DiganosiseList[i].ki67 == 0 || this.DiganosiseList[i].ki67 ==null){this.DiganosiseList[i].ki67text = '';this.wk_Heddin_ki67[i] =true; }else{ this.DiganosiseList[i].ki67text = 'ki67 :' + this.DiganosiseList[i].ki67;this.wk_Heddin_ki67[i]=false;};
                if (this.DiganosiseList[i].hpv == '' || this.DiganosiseList[i].hpv ==null){this.DiganosiseList[i].hpv = '' ;this.wk_Heddin_hpv[i] = true;}else{ this.DiganosiseList[i].hpv = 'HPV Status:' +  this.DiganosiseList[i].hpv;this.wk_Heddin_hpv[i] = false;};
                if (this.DiganosiseList[i].digstage == '' || this.DiganosiseList[i].digstage ==null){this.DiganosiseList[i].digstage = '' ;this.wk_Heddin_digstage[i] = true;}else{ this.DiganosiseList[i].digstage = 'Stage:' +  this.DiganosiseList[i].digstage;this.wk_Heddin_digstage[i] = false;};
                if (this.DiganosiseList[i].dign == '' || this.DiganosiseList[i].dign ==null){this.DiganosiseList[i].dign = '' ;this.wk_Heddin_dign[i] = true;}else{ this.DiganosiseList[i].dign = 'N :' +  this.DiganosiseList[i].dign;this.wk_Heddin_dign[i] = false;};
                if (this.DiganosiseList[i].digm == '' || this.DiganosiseList[i].digm ==null){this.DiganosiseList[i].digm = '' ;this.wk_Heddin_digm[i] = true;}else{ this.DiganosiseList[i].digm = 'M :' +  this.DiganosiseList[i].digm;this.wk_Heddin_digm[i] = false;};
                if (this.DiganosiseList[i].digt == '' || this.DiganosiseList[i].digt ==null){this.DiganosiseList[i].digt = '' ;this.wk_Heddin_digt[i] = true;}else{ this.DiganosiseList[i].digt = 'T :' +  this.DiganosiseList[i].digt;this.wk_Heddin_digt[i] = false;};

                this.DiganosiseList[i].digmain = notes

              }
            })

  }
EditDiganosis(item : DiganosisModel){
  this.chkuser = item.username;
  if( item.username == this.storage.retrieve('stgusername') )
    {
    this.storage.store('stgPatientCode',item.patientcode);
    this.storage.store('stgVisitDate',item.digdate)
    const dialogRef = this.dialogref.open(DiganosticEntryComponent,
      {
        data: {
          dataKey: this.diganosis,
        },
        width: '80vw',
        height: '40vw',
      });
      dialogRef.afterClosed().subscribe(result => {
        // Refresh the same route
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/DoctorObservation'], {
            queryParams: {
              patientid: this.patientcode,
              patientname: this.Patientname
            }
          });
        });
      });


    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDiganosis();
        dialogSubmitSubscription.unsubscribe();

      });
    }
    else
    {
      this.MesgWarrning();
    }
}
MesgWarrning(){

  swal({
    title: 'Check User',
    text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK',
    //cancelButtonText: 'No, keep it',
  })
  ;

}
MessegeDelete(item  : DiganosisModel){
  this.chkuser = item.username;
  if( item.username == this.storage.retrieve('stgusername') )
    {
 swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.storage.store('stgPatientCode',item.patientcode);
        this.storage.store('stgVisitDate',item.digdate)
        this.DeleteDiganosis();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  else{
    this.MesgWarrning();
  }
}
  DeleteDiganosis(){

      this.diganosisService.deleteDiganosis(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode')).subscribe(
          (data: DiganosisModel) => {
            this.RetriveDiganosis();
          }
        );
        this. RetriveDiganosis();
  }
openDialog(){
  if(this.patientcode !='0000' || this.patientcode != null ){

  var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
  this.storage.store('stgVisitDate',wk_Date )
  this.storage.store('stgPatientCode',this.patientcode);

    const dialogRef = this.dialogref.open(DiganosticEntryComponent,
      {
        data: {
          dataKey: this.stores

        },
        width: '80vw',
        height: '40vw',
      });
      dialogRef.afterClosed().subscribe(result => {
        // Refresh the same route
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/DoctorObservation'], {
            queryParams: {
              patientid: this.patientcode,
              patientname: this.Patientname
            }
          });
        });
      });


    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDiganosis();
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }
}
